import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from "@angular/core";
import { FormGroup,  FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "../../global/global";
import { ToastrService } from "ngx-toastr";
import * as CONSTANT from "../../services/constants";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { HttpBackend, HttpClient } from "@angular/common/http"
import { ImageUrls } from "src/app/services/s3buket";
import { DatePipe } from "@angular/common";
@Component({
  selector: "app-complete-profile",
  templateUrl: "./complete-profile.component.html",
  styleUrls: ["./complete-profile.component.css"]
})
export class CompleteProfileComponent implements OnInit {
  userData: any;
  fileUpload;
  dummyImage:any;
  globalUrl = ImageUrls.BaseUrl + ImageUrls.directories.users
  modalRef?: BsModalRef;
  form: FormGroup;
  otpForm: FormGroup;
  showError = false;
  showErrorPhoneNo = false;
  showErrorImage = false;
  showDiv = true;
  showErrorUrlNotMatch = false;
  showErrorOtp = false;
  public loading = false; 
  countryCode =1;
  minDate = new Date();
  maxDate = new Date(this.minDate.getFullYear() - 18, this.minDate.getMonth(), this.minDate.getDate());
  // awards list
  awardList:any=[]; 
  actionUpload = "";
  //mobile otp
  @ViewChild("ngOtpInput", { static: false}) ngOtpInput: any;
  title ="Verify"; 

  isReadonly = false;
  phoneVerified; 
  config = { 
    placeholder: "-",
    length: 4 
  };
  otp: string | undefined;
  showOtpComponent = true;
  display:any;
   // cropper
   image;
   profileImageUpload;
   imageUpload;
   show: boolean = false;
   loader = false;
   @Output() changeDetected: EventEmitter<any> = new EventEmitter<any>();
   @Input() objectProperty: any;
   @Output() valueChange = new EventEmitter();
   objectProp: any;
   onSelect:any;
  statSec:number | undefined;
  constructor(private modalService: BsModalService,private formBuilder: FormBuilder,public route: ActivatedRoute, private router: Router,private api: AdminService,private toastrService: ToastrService,private http: HttpClient, private handler: HttpBackend, private datePipe: DatePipe) {
    this.form = this.formBuilder.group({
      customPronouns: [""],
      profileImage: [""],
      pronounsType: [""],
      phoneNumber: ["", Validators.compose([Validators.maxLength(250)])],
      // countryCode: ["+1"],
      gender: ["", Validators.compose([Validators.required])],
      bio: ["", Validators.compose([Validators.required,Validators.maxLength(250)])],
      serviceDisabled: ["", Validators.compose([Validators.required])],
      dateOfBirth: ["", Validators.compose([Validators.required])],
      honorAwardArray: [""],
      location: ["", Validators.compose([Validators.required])],
      zipCode: [""],
      scoreLink: ["", Validators.compose([Validators.pattern(CONSTANT.URL_REGEXForPersonality)])],
      latitude: [""],
      longitude: [""],
      // linkedInLink: [""],
    });
    this.otpForm = this.formBuilder.group({
      otp:""
    })
   }
  ngOnInit(): void {   
    this.getUserDetail(); 
    this.timer(1); 
  }
  
  // date picker only accpedct number
  onKeyDown(event: KeyboardEvent) {
    const key = event.key;
    if (!/^\d+$/.test(key)) {
      event.preventDefault();
    }
  }
  getUserDetail() {
    this.api.getDatas(apiUrl._getUserInfo)
        .subscribe(async (res) => {
          this.userData = res.data;
          this.imageUpload = res.data.profileImage;
          let time;
          if(res.data.dateOfBirth != null){
            time = new Date(res.data.dateOfBirth);
          }
          if(this.userData.isPhoneVerified == 1){
            this.title = "Change";
            this.isReadonly = !this.isReadonly;
          } else{
            this.isReadonly = false
          }
          this.userData.userAwardsAndHonors.map((awrad) =>{
            this.awardList.push({name:awrad.name, orderByIndex: awrad.orderByIndex});
          })
          this.onSelect = this.userData.pronounsType
          this.form.patchValue({
            ...res.data,
            dateOfBirth:time,
          }) 
          
    })
  }
  // image upload
  // upload(event) { 
	// 	const files = event.target.files; 
   
  //    this.fileUpload = files[0];
	// 	this.uploadFileToS3();
	// }
	
// image upload
upload(event) { 
  if (event.target.files.length == 0) {
    return
  }
  if (event.target.files[0].type.includes("image") && event.target.files[0].name.split(".")[1] !="jfif") {
    this.show = true;
    this.loader = true;
    this.objectProp = { "event": event, "directory": "users/", "imagewidthsize": false, "imageheightsize": false, "aspectRatio": 1 / 1, "roundCropper": false,"maintainAspectRatio" : true,"typeCropper": 1, "cropperHeight" : 500, "cropperMinWidth" : 500,"showOnlySquare" : true };
  } else{
    this.toastrService.error("Please upload only Jpg,Jpeg & Png images!");
    this.show = false;
    this.showError = true;
    setTimeout(() => {
      this.showError = false;
    }, 5000);      
  }
}
catchFile(event) {  
  this.show = false; 
  if(event.image1 != "" && event.file !=""){
    this.profileImageUpload = event.image1;
    this.imageUpload=  event.file;
    this.show = false;
    this.form.patchValue({
      profileImage:this.imageUpload
    })
    this.api.loader(false)
  }  
}   
onFileUploaded(rawImage, fileName) { 
}
 
onChangeDetected(event) {
}
close(){
  this.show = false;
} 
	uploadFileToS3() {
		const data = {
			"directory":ImageUrls.directories.users,
			"fileName": this.fileUpload.name,
			"contentType": this.fileUpload.type
		} 
		this.api.postData(apiUrl._upload, data)
			.subscribe(res => {
				this.http = new HttpClient(this.handler);
				this.http.put<any>(res.data.uploadURL, this.fileUpload).subscribe(response => {
         this.form.value.profileImage=res.data.fileName;
         this.dummyImage= this.globalUrl+ res.data.fileName;
         this.form.patchValue({
          profileImage:res.data.fileName
         })
         
				})
			})
	} 
  // add awards
  addMore(input, name){
    if(name != null && name.trim() != ""){
      this.awardList.push({name, orderByIndex: this.awardList.length + 1});
      input.value = "";
    }
    // this.form.value.honorAwardArray =this.awardList
    this.form.patchValue({
      honorAwardArray:this.awardList
    })
  }
  deleteLanguage(name) {
    const index = this.awardList.indexOf(name);
    if( index >= 0) this.awardList.splice(index, 1);
  }
  // get current location
  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position: any) => {
        if (position) {
          this.form.value.latitude = position.coords.latitude;
          this.form.value.longitude = position.coords.longitude;           
          this.form.value.longitude = position.coords.longitude;
          let url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=" + this.form.value.latitude + "," + this.form.value.longitude + "&key=AIzaSyCDi96O9BAjbJUHBC-DTtw4QNmo3ekxIgA";
          this.getJSON(url);
        }
      },
        // (error: PositionError) => console.log(error)
      );
      this.modalService.hide();
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }
  getJSON(data:any){
    this.http = new HttpClient(this.handler);
    this.http.get(data).subscribe((res:any) => {
      let zipCode:any;
      for (let i = 0; i < res.results.length; i++){
        for (let j = 0; j < res.results[i].address_components.length; j++){
          if (res.results[i].address_components[j].types == "postal_code") {
            zipCode = res.results[i].address_components[j].long_name;
          }
        }
      }
      this.form.patchValue({
        location : res.results[0].formatted_address,
        latitude : res.results[0].geometry.location.lat.toString(),
        longitude : res.results[0].geometry.location.lng.toString(),
        zipCode : zipCode
      })
    })
  }

  onAddressChange(address: any) {
    this.form.value.location = address.formatted_address;
    this.form.patchValue({
      location : address.formatted_address,
    })
    this.form.value.latitude = address.geometry.location.lat().toString();
    this.form.value.longitude = address.geometry.location.lng().toString();
    for (let i = 0; i < address.address_components.length; i++){
      for (let j = 0; j < address.address_components[i].types.length; j++){
        if (address.address_components[i].types[j] == "postal_code") {
          this.form.value.zipCode = address.address_components[i].long_name;
          this.form.patchValue({
            location : this.form.value.location,
            latitude : this.form.value.latitude.toString(),
            longitude : this.form.value.longitude.toString(),
            zipCode: this.form.value.zipCode
          })
        }
      }
    }
  }
  // 
  onChange(e) {
    this.form.value.gender= e.target.value;
 }
  // 
  onChangeService(e) {
    this.form.value.serviceDisabled= e.target.value;
 }
  // submit from
  onSubmit(){
    if(this.form.value.scoreLink != null){
      var t = "https://www.16personalities.com"; 
      if(!this.form.value.scoreLink.toString().startsWith(t)){
        this.showErrorUrlNotMatch = true;
        setTimeout(() => {
          this.showErrorUrlNotMatch = false;
        }, 3000);
        return
      } 
    }
    this.form.value.countryCode= "+1"; 
    if(this.form.value.serviceDisabled == 0){
      this.showError=true;
      setTimeout(() => {
        this.showError=false;
      }, 3000);
    }
    if(this.form.value.honorAwardArray ==""){
      delete this.form.value.honorAwardArray;
    }
    if(this.form.value.zipCode == null){
      delete this.form.value.zipCode;
    }
    if(this.form.valid && this.form.value.serviceDisabled != 0){
      this.api.putData(apiUrl._updateProfile, this.removeEmptyFiled(this.form))
      .subscribe(async (res) => { 
        this.loading = false 
        this.router.navigate(["/resume-build"]);
      })
    } else{
      this.showError=true;
      setTimeout(() => {
        this.showError=false;
      }, 3000);
    }
  }
  // check if only number
  preventNumbers(event): boolean { 
    event = (event) ? event : window.event;
    var charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
  }

  // radio button
  change(value) {
    this.form.controls['phoneNumber'].reset(); 
    this.isReadonly=false;
    this.isReadonly = !this.isReadonly;
    this.title ="Verify";
  }
  
  removeEmptyFiled(form){
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }

    return formValues
  }

  // otp popup
  verifyPhone(otpVerify: TemplateRef<any>) {  
    this.title ="Verify";
    let Number=this.form.value.phoneNumber
    
    if(Number == null || Number == ""){
      this.showErrorPhoneNo=true;
      setTimeout(() => {
        this.showErrorPhoneNo=false;
      }, 3000);
      return
    }else{
    const data={
      "countryCode":"+1",
      "mobileNo":Number,
    }
    this.api.putData(apiUrl._userMobileVerify,data)
      .subscribe(async (res) => { 
        this.toastrService.success("", "OTP Send Successfully on your Mobile No."); 
        this.modalRef = this.modalService.show(
          otpVerify,
          Object.assign({}, { class: "modal-sm addModal maxWidth centerAlign" })
        ); 
    })
  }
  }
  resendOTP(){
    this.otp = ""
    // this.ngOtpInput.setValue(""); 
    this.statSec = 0;
    this.title ="Verify";
    let Number=this.form.value.phoneNumber
    const data={
      "countryCode":"+1",
      "mobileNo":Number,
    }
    this.api.putData(apiUrl._userMobileVerify,data)
      .subscribe(async (res) => { 
        this.toastrService.success("", "OTP has been re-sent on your mobile number"); 
    })
  }
  
openModal(template: TemplateRef<any>) { 
  this.modalRef = this.modalService.show(
    template,
    Object.assign({},this.config, { class: "modal-md addModal centerAlign" })
  ); 
}
  closeModal(){  
   this.modalService.hide();
  }
  onOtpChange(otp) {
    this.otp = otp;
  }
  setVal(val) {
    this.ngOtpInput.setValue(val); 
  }
  timer(minute) {
    // let minute = 2;
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 30;

    const prefix = minute < 10 ? "0" : "";

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) { 
        clearInterval(timer);
      }
    }, 3000);
  }
  verify(){
    if(this.otp == null){
      this.showErrorOtp = true;
      setTimeout(() => {
        this.showErrorOtp = false
      }, 3000);
      return
    }
    const data ={
      "otp":this.otp,
    }
    this.api.putData(apiUrl._userMobileVerifyOtp, data)
      .subscribe(async (res) => {
        this.toastrService.success("OTP Verify successfully!");
        this.title ="Change";
        localStorage.setItem("title","Change"); 
        this.modalService.hide();
      }, err => {
          this.toastrService.success("Error", err.error.message)
      })
  }

  onSelectCustom(e){
    this.onSelect = e.target.value;
    if(this.onSelect == 'Add custom'){
      this.form.controls['customPronouns'].setValidators([Validators.required])
      this.form.controls['customPronouns'].updateValueAndValidity();
    } else {
      this.form.controls['customPronouns'].setValidators(null);
      this.form.controls['customPronouns'].updateValueAndValidity();
      this.form.controls['customPronouns'].setValue(null);
    }
   }
   onInputCustom(e){
    let val = e.target.value;
    if(this.onSelect == 'Add custom' && val == '' && val == null){
      this.form.controls['customPronouns'].setValidators([Validators.required])
      this.form.controls['customPronouns'].updateValueAndValidity();
    }
  }
}
